/** 날짜 이동은 UTC로 계산하여 시간대와 월말 길이에 영향을 받지 않습니다. */
export function calendarKeyboardDate(value: string, key: string, shift = false): string | undefined {
  const date = new Date(`${value}T00:00:00Z`);
  if (Number.isNaN(date.getTime())) return undefined;
  const weekday = date.getUTCDay();
  const offset = ({ ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7, Home: -weekday, End: 6 - weekday } as Record<string, number>)[key];
  if (offset !== undefined) date.setUTCDate(date.getUTCDate() + offset);
  else if (key === 'PageUp' || key === 'PageDown') {
    const day = date.getUTCDate();
    date.setUTCDate(1);
    date.setUTCMonth(date.getUTCMonth() + (key === 'PageUp' ? -1 : 1) * (shift ? 12 : 1));
    const last = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
    date.setUTCDate(Math.min(day, last));
  } else return undefined;
  const year = date.getUTCFullYear();
  return year >= 1000 && year <= 9999 ? date.toISOString().slice(0, 10) : undefined;
}
